export enum DocumentPageRotation {
  None = 'None',
  Rotate90 = 'Rotate90',
  Rotate180 = 'Rotate180',
  Rotate270 = 'Rotate270'
}

export interface DocumentPagePreferencesModel {
  page: number;
  sizing: string;
  position: string;
  rotation: DocumentPageRotation;
}
